import { __assign } from "tslib";
import React from 'react';
import UnknownThumbHtmlView from './UnknownHtml';
import UnknownThumbReactView from './Unknown';
var UnknownThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(UnknownThumbHtmlView, __assign({}, props));
    }
    return React.createElement(UnknownThumbReactView, __assign({}, props));
};
UnknownThumbView.displayName = 'UnknownThumbView';
export default UnknownThumbView;
//# sourceMappingURL=index.js.map